import { ChevronsDownUp, ChevronsUpDown, ZoomIn, ZoomOut } from 'lucide-react';
import { useIntl } from '@/core/i18n/use-intl';
import { cn } from '@/shared/utils';

import { Button } from './button';

interface TimelineControlsProps {
  onExpandAll?: () => void;
  onCollapseAll?: () => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
}

export function TimelineControls({
  onExpandAll,
  onCollapseAll,
  onZoomIn,
  onZoomOut,
}: TimelineControlsProps) {
  const { t } = useIntl();

  return (
    <div className="inline-flex rounded-md border border-input h-9 bg-background shadow-xs">
      {onExpandAll && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onExpandAll}
          aria-label={t('actions.expandAll')}
          className="rounded-r-none border-r border-input text-muted-foreground"
        >
          <ChevronsUpDown className="size-4" />
        </Button>
      )}
      {onCollapseAll && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onCollapseAll}
          aria-label={t('actions.collapseAll')}
          className={cn(
            'rounded-l-none rounded-r-none text-muted-foreground',
            (onZoomIn || onZoomOut) && 'border-r border-input'
          )}
        >
          <ChevronsDownUp className="size-4" />
        </Button>
      )}
      {onZoomIn && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onZoomIn}
          aria-label={t('actions.zoomIn')}
          className={cn(
            !onExpandAll && !onCollapseAll
              ? 'rounded-r-none border-r border-input text-muted-foreground'
              : 'rounded-none border-r border-input text-muted-foreground'
          )}
        >
          <ZoomIn className="size-4" />
        </Button>
      )}
      {onZoomOut && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onZoomOut}
          aria-label={t('actions.zoomOut')}
          className="rounded-l-none border-input text-muted-foreground"
        >
          <ZoomOut className="size-4" />
        </Button>
      )}
    </div>
  );
}
